import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    br: "br",
    em: "em",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "SELLER-NOTE Co.Ltd."
      }), " (hereinafter referred to as the \"Company\") establishes and discloses the following privacy policy to protect users' personal information and rights in accordance with the Personal Information Protection Act and to ensure the smooth handling of users' grievances related to personal information. The Company will notify users of any revisions to this privacy policy through website announcements (or individual notifications)."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Updated:"
      }), " December 13, 2024 (Effective: December 20, 2024)"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 1 (Purpose of Processing Personal Information)"
    }), "\n", _jsxs(_components.p, {
      children: ["The Company collects, uses, and processes personal information for the following purposes. Personal information is collected within the scope permitted by law through the website, phone, email, written forms, fax, live consultations, or receipt from entrusted companies. The Company will not use personal information for purposes other than those specified below. If the purpose of use changes, the Company will take necessary measures, such as obtaining separate consent, in accordance with the ", _jsx(_components.strong, {
        children: "Personal Information Protection Act of the Republic of Korea"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 2 (Specific Purposes and Items of Personal Information Processed)"
    }), "\n", _jsx(_components.p, {
      children: "The Company collects the following personal information items for the specified purposes:"
    }), "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Category"
          }), _jsx(_components.th, {
            children: "Collected Items"
          }), _jsx(_components.th, {
            children: "Purpose"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Membership Registration and Management"
          }), _jsx(_components.td, {
            children: "User name, contact information, email, business representative name, contact information, email, business bank account number, address, fax number"
          }), _jsx(_components.td, {
            children: "User identity verification and membership management for website and app usage"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Handling Complaints (Consultation, Grievances, etc.)"
          }), _jsx(_components.td, {
            children: "User name, contact information, email, details of the complaint"
          }), _jsx(_components.td, {
            children: "To handle complaints (consultations, grievances, etc.)"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Managing Customer-Related Businesses"
          }), _jsx(_components.td, {
            children: "Business representative name, contact information, email, address"
          }), _jsx(_components.td, {
            children: "Registration and management of customer-related businesses (suppliers, customs agents, etc.)"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Provision of Goods or Services: Export/Import Transport Services"
          }), _jsx(_components.td, {
            children: "Exporter/Importer representative name, contact information, email, address, export/import-related documents such as BL, C/I, P/L, personal information of Exporter/Importer, and declarants (name, contact information, email, address)"
          }), _jsx(_components.td, {
            children: "To provide services such as export/import transportation"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Provision of Goods or Services: Fulfillment Services"
          }), _jsx(_components.td, {
            children: "Sender name, contact information, recipient name, contact information, address"
          }), _jsx(_components.td, {
            children: "To provide logistics services"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Provision of Goods or Services: Overseas Remittance Services"
          }), _jsxs(_components.td, {
            children: ["1) For individual business owners:", _jsx(_components.br, {}), "Representative name, address, unique identification number (or resident registration number), bank account number, (if acting through an agent) agent name, address, unique identification number (or resident registration number)", _jsx(_components.br, {}), _jsx(_components.br, {}), "2) For corporate entities:", _jsx(_components.br, {}), "Representative name, address, unique identification number (or resident registration number), bank account number, (if acting through an agent) agent name, address, unique identification number (or resident registration number), corporate shareholder and executive information, date of birth (or resident registration number) ", _jsx(_components.br, {}), _jsx(_components.br, {}), "3) Recipient information:", _jsx(_components.br, {}), "Recipient representative name, bank account number, contact information, email, address"]
          }), _jsx(_components.td, {
            children: "To provide overseas remittance services"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Customer Service Statistics"
          }), _jsx(_components.td, {
            children: "Name, email, contact information, address"
          }), _jsx(_components.td, {
            children: "To prepare statistics for improving customer service"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Information and Event Notifications"
          }), _jsx(_components.td, {
            children: "Name, email, contact information"
          }), _jsx(_components.td, {
            children: "To provide information and notifications about services and events"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Automatically Collected Items"
          }), _jsx(_components.td, {
            children: "Device information (OS details, device identifier, screen size), visit (access log) records, service usage records (including misuse and transaction history)"
          }), _jsx(_components.td, {
            children: "For security, privacy, safety, misuse prevention, marketing, and personal data retention period management purposes"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 3 (Processing and Retention Period of Personal Information)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "The Company, in principle, destroys users’ personal information without delay when the user withdraws membership from the website or app, or when the purpose of collection and use of personal information has been achieved. However, the Company may retain and process personal information within the period stipulated by relevant laws or the retention period consented to by the user at the time of collection."
      }), "\n", _jsx(_components.li, {
        children: "The specific processing and retention periods for personal information are as follows:"
      }), "\n"]
    }), "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Category"
          }), _jsx(_components.th, {
            children: "Collected Items"
          }), _jsx(_components.th, {
            children: "Retention Period"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Membership Registration and Management"
          }), _jsx(_components.td, {
            children: "User name, contact information, email, business representative name, contact information, email, business bank account number, address, fax number"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Handling Complaints (Consultation, Grievances, etc.)"
          }), _jsx(_components.td, {
            children: "User name, contact information, email, details of the complaint"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Managing Customer-Related Businesses"
          }), _jsx(_components.td, {
            children: "Business representative name, contact information, email, address"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Provision of Goods or Services: Export/Import Transport Services"
          }), _jsx(_components.td, {
            children: "Exporter/Importer representative name, contact information, email, address, export/import-related documents such as BL, C/I, P/L, personal information of Exporters/Importers, and declarants (name, contact information, email, address)"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal or termination of the service contract, unless otherwise specified by relevant laws"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Provision of Goods or Services: Fulfillment Services"
          }), _jsx(_components.td, {
            children: "Sender name, contact information, recipient name, contact information, address"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal or termination of the service contract, unless otherwise specified by relevant laws"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Provision of Goods or Services: Overseas Remittance Services"
          }), _jsxs(_components.td, {
            children: ["1) For individual business owners:", _jsx(_components.br, {}), "Representative name, address, unique identification number (or resident registration number), bank account number, (if acting through an agent) agent name, address, unique identification number (or resident registration number)", _jsx(_components.br, {}), _jsx(_components.br, {}), "2) For corporate entities:", _jsx(_components.br, {}), "Representative name, address, unique identification number (or resident registration number), bank account number, (if acting through an agent) agent name, address, unique identification number (or resident registration number), corporate shareholder and executive information, date of birth (or resident registration number)", _jsx(_components.br, {}), _jsx(_components.br, {}), "3) Recipient information:", _jsx(_components.br, {}), "Recipient representative name, bank account number, contact information, email, address"]
          }), _jsx(_components.td, {
            children: "Until membership withdrawal or termination of the partnership agreement, unless otherwise specified by relevant laws"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Customer Service Statistics"
          }), _jsx(_components.td, {
            children: "Name, email, contact information, address"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Information and Event Notifications"
          }), _jsx(_components.td, {
            children: "Name, email, contact information"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal or withdrawal of consent for receiving such information"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Automatically Collected Items"
          }), _jsx(_components.td, {
            children: "Device information (OS details, device identifier, screen size), visit (access log) records, service usage records (including misuse and transaction history)"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal or withdrawal of consent for receiving such information"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 4 (Provision of Personal Information to Third Parties)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["The Company processes users' personal information only within the scope specified in this policy and provides it to third parties only in cases falling under Clause 17 of the ", _jsx(_components.em, {
          children: "Personal Information Protection Act"
        }), " of South Korea, such as obtaining the user's consent or under specific legal provisions."]
      }), "\n", _jsx(_components.li, {
        children: "The Company provides personal information to third parties with the user's consent as follows:"
      }), "\n"]
    }), "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Category"
          }), _jsx(_components.th, {
            children: "Recipient"
          }), _jsx(_components.th, {
            children: "Provided Personal Information Items"
          }), _jsx(_components.th, {
            children: "Purpose of Use by the Recipient"
          }), _jsx(_components.th, {
            children: "Retention and Usage Period of the Recipient"
          })]
        })
      }), _jsx(_components.tbody, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Provision of Goods or Services: Overseas Remittance Services"
          }), _jsx(_components.td, {
            children: "U Fintech Hub Inc."
          }), _jsxs(_components.td, {
            children: ["1) For individual business owners:", _jsx(_components.br, {}), "Representative name, address, unique identification number (or resident registration number), bank account number, (if acting through an agent) agent name, address, unique identification number (or resident registration number)", _jsx(_components.br, {}), _jsx(_components.br, {}), "2) For corporate entities:", _jsx(_components.br, {}), "Representative name, address, unique identification number (or resident registration number), bank account number, (if acting through an agent) agent name, address, unique identification number (or resident registration number), corporate shareholder and executive information, date of birth(or resident registration number)", _jsx(_components.br, {}), _jsx(_components.br, {}), "3) Recipient information:", _jsx(_components.br, {}), "Recipient representative name, bank account number, contact information, email, address"]
          }), _jsx(_components.td, {
            children: "To provide overseas remittance services"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal or termination of the partnership agreement, unless otherwise specified by relevant laws"
          })]
        })
      })]
    }), "\n", _jsxs(_components.ol, {
      start: "3",
      children: ["\n", _jsxs(_components.li, {
        children: ["The Company may use, disclose, or transfer personal information to third parties in compliance with applicable laws under the following circumstances:\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "When required by applicable laws, including those outside the user’s country of residence"
          }), "\n", _jsx(_components.li, {
            children: "In response to requests from investigative authorities based on legal procedures and methods stipulated by law"
          }), "\n", _jsx(_components.li, {
            children: "Upon requests from public or government institutions, including those outside the user’s country of residence, for purposes of national security and/or law enforcement"
          }), "\n", _jsx(_components.li, {
            children: "In cases of restructuring, mergers, acquisitions, joint ventures, transfers, or other dispositions of all or part of the Company’s business, assets, or shares (including those related to bankruptcy or similar proceedings)"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 5 (Exceptions to the Provision of Personal Information to Third Parties)"
    }), "\n", _jsx(_components.p, {
      children: "The Company provides users' personal information to partner companies only within the scope and methods specified in Clauses 1 and 2 of this Privacy Policy. Personal information is not used for purposes other than service-related purposes, nor is it provided to other parties or companies. However, there are exceptions where personal information may be provided without the user's prior consent, as outlined below:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "When the user has previously disclosed their personal information (e.g., through posting, commenting, etc.)"
      }), "\n", _jsx(_components.li, {
        children: "When required by applicable laws or in response to requests from investigative authorities for investigative purposes"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 6 (Delegation of Personal Information Processing)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "The Company delegates portions of its service-related tasks to external contractors to ensure efficient service delivery. The Company establishes and supervises necessary measures to ensure that the entrusted parties process personal information securely in compliance with the Personal Information Protection Act."
      }), "\n", _jsx(_components.li, {
        children: "Personal information will not be provided to subcontractors unless the user is utilizing services related to the delegated tasks."
      }), "\n"]
    }), "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Category"
          }), _jsx(_components.th, {
            children: "Purpose and Scope of Tasks"
          }), _jsx(_components.th, {
            children: "Retention and Use Period"
          }), _jsx(_components.th, {
            children: "Subcontractor"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Payment Processing Service"
          }), _jsx(_components.td, {
            children: "Tasks related to payment processing (e.g., virtual account setup)"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal or upon termination of the outsourcing contract"
          }), _jsx(_components.td, {
            children: "Hecto Financial Corp."
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Provision of Goods or Services: Import/Export Transportation Services"
          }), _jsx(_components.td, {
            children: "Tasks related to import/export transportation"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal or upon termination of the outsourcing contract"
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://shipda.notion.site/ShipDa-Partner-list-ce50381297de42a39da3cce32216c3e8",
              children: "List of Partners"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Provision of Goods or Services: Import/Export Transportation Services"
          }), _jsx(_components.td, {
            children: "Customs-related tasks for import/export transportation"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal, contract termination, or deletion of customs broker registration"
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://shipda.notion.site/ShipDa-Partner-list-ce50381297de42a39da3cce32216c3e8",
              children: "List of Partners"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Provision of Goods or Services: Fulfillment and Shipping Services"
          }), _jsx(_components.td, {
            children: "Logistics tasks, including transport and delivery"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal or upon termination of the outsourcing contract"
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://shipda.notion.site/ShipDa-Partner-list-f4436de96dc74861898fe362a0c69ce2",
              children: "List of Partners"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Web Server Information Processing Service"
          }), _jsx(_components.td, {
            children: "Hosting and management tasks related to web server operations"
          }), _jsx(_components.td, {
            children: "Until membership withdrawal or upon termination of the outsourcing contract"
          }), _jsx(_components.td, {
            children: "Amazon Web Services Korea LLC"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 7 (Overseas Transfer of Collected Personal Information)"
    }), "\n", _jsx(_components.p, {
      children: "The Company provides personal information to third parties overseas as outlined below and may process users' personal information on servers located outside the user’s country of residence."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "List of Receiving Parties and Contact Information:"
          }), _jsx(_components.br, {}), "\n", _jsx(_components.a, {
            href: "https://shipda.notion.site/ShipDa-Partner-list-ce50381297de42a39da3cce32216c3e8",
            children: "List of Partners"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Timing and Method of Transfer:"
          }), _jsx(_components.br, {}), "\nAt the time of using related services provided on the website, personal information is transmitted via network."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Personal Information Transferred:"
          }), _jsx(_components.br, {}), "\nAmong the items collected under Clause 2, the category titled ", _jsx(_components.em, {
            children: "“Provision of Goods or Services: Export/Import Transport Services.”"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Purpose of Use by the Receiving Party:"
          }), _jsx(_components.br, {}), "\nPersonal information is transferred to external entities to perform necessary tasks for providing the services listed under Clause 2. The Company ensures that the receiving parties do not violate applicable data protection laws through proper oversight and management."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Retention and Use Period of the Receiving Party:"
          }), _jsx(_components.br, {}), "\nPersonal information is retained until membership withdrawal or the termination of the relevant contract. Subsequently, the information is promptly destroyed unless retention is mandated by law, in which case it is preserved for the legally specified period."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Right to Refuse Consent and Potential Consequences:"
          }), _jsx(_components.br, {}), "\nUsers have the right to refuse the collection of their personal information. However, refusal may result in restricted access to services."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 8 (Rights and Obligations of Data Subjects and Exercise Methods)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Data subjects may exercise the following rights related to personal information protection with the Company at any time:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Request access to personal information"
          }), "\n", _jsx(_components.li, {
            children: "Request correction of errors, if any"
          }), "\n", _jsx(_components.li, {
            children: "Request deletion of personal information"
          }), "\n", _jsx(_components.li, {
            children: "Request suspension of processing"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The rights outlined in Paragraph 1 can be exercised through written requests, phone calls, emails, facsimiles (FAX), or other methods. The Company must respond promptly. If the data subject requests correction or deletion of errors in their personal information, the Company will cease using or providing the information until the correction or deletion is complete."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The rights outlined in Paragraph 1 may also be exercised by a legal representative of the data subject or a delegated person. In such cases, a power of attorney must be submitted, as prescribed in Form 11 of the Enforcement Rules of the Personal Information Protection Act."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Data subjects shall not violate applicable laws, including the South Korean Personal Information Protection Act, by infringing upon the personal information or privacy of themselves or others in relation to the Company's handling of such information."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Requests for access to or suspension of processing of personal information may be restricted under Articles 35(5) and 37(2) of the South Korean ", _jsx(_components.em, {
            children: "Personal Information Protection Act"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Requests for correction or deletion of personal information cannot be made if other laws specify that the personal information must be collected."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "When the Company receives requests for access, correction, deletion, or suspension of processing under the rights of data subjects, it verifies whether the requester is the data subject or a legitimate representative."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 9 (Destruction of Personal Information)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company will promptly destroy personal information once its retention period has expired, or its processing purpose has been achieved, making the information no longer necessary."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If the retention period for personal information agreed upon by the data subject has expired, or the processing purpose has been achieved, but preservation of the personal information is required by other laws, the Company will transfer the information to a separate database (DB) or store it in a different location."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The procedures, timelines, and methods for the destruction of personal information are as follows:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.strong, {
                children: "Destruction Procedures"
              }), _jsx(_components.br, {}), "\nInformation entered by users will either be stored for a certain period based on internal policies and relevant laws or destroyed immediately upon achieving its purpose."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsx(_components.p, {
              children: _jsx(_components.strong, {
                children: "Destruction Timelines"
              })
            }), "\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: "If the retention period for personal information has expired: Within five (5) days from the expiration date."
              }), "\n", _jsx(_components.li, {
                children: "If personal information becomes unnecessary (e.g., upon achieving its processing purpose, service discontinuation, or business termination): Within five (5) days from the date it is deemed unnecessary."
              }), "\n"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsx(_components.p, {
              children: _jsx(_components.strong, {
                children: "Destruction Methods"
              })
            }), "\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: "Personal information in electronic file format will be permanently deleted using technical methods that prevent its recovery."
              }), "\n", _jsx(_components.li, {
                children: "Personal information printed on paper will be shredded or incinerated."
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 10 (Installation and Operation of Automatic Personal Information Collection Devices (Cookies) and How to Reject Them)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company uses cookies and other similar technologies to provide customized services to members."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "A cookie is a small text file sent by the server operating the website to the user's browser, which may be stored on the user's computer's hard disk. The Company uses cookies to analyze access frequency, visit duration, track member preferences and interests, monitor participation in various events, and count the number of visits for targeted marketing."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Members have the option to accept or reject the installation of cookies. By adjusting the settings in their mobile application or web browser, members can either allow cookies or reject the storage of all cookies. However, rejecting cookies may make it difficult to use services that require login."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "How to Reject Cookies: Members can reject cookies by selecting options in their mobile application or web browser to either allow all cookies, request confirmation each time a cookie is saved, or reject the storage of all cookies."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 11 (Collection and Transmission of Behavioral Information)"
    }), "\n", _jsx(_components.p, {
      children: "When a data subject visits the Company’s website, their behavioral information may be automatically collected and transmitted to web analytics tool providers, such as Google, through web log analysis tools."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 12 (Measures to Ensure the Security of Personal Information)"
    }), "\n", _jsx(_components.p, {
      children: "The Company takes the following measures to ensure the security of personal information:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Administrative Measures"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Establishment and implementation of internal management plans"
          }), "\n", _jsx(_components.li, {
            children: "Regular staff training on data protection"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Technical Measures"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Access control management for personal information processing systems"
          }), "\n", _jsx(_components.li, {
            children: "Installation of access control systems"
          }), "\n", _jsx(_components.li, {
            children: "Encryption of unique identifiers and sensitive data"
          }), "\n", _jsx(_components.li, {
            children: "Implementation of security programs"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Physical Measures"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Access control for data centers and document storage facilities"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 13 (Personal Information Protection Officer, etc.)"
    }), "\n", _jsx(_components.p, {
      children: "The Company has designated the following Personal Information Protection Officer and department to oversee and take responsibility for personal information processing. They handle inquiries, complaints, and remedies related to the processing of personal information."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Personal Information Protection Officer"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Name: Jongha Kim"
          }), "\n", _jsx(_components.li, {
            children: "Position: CTO"
          }), "\n", _jsxs(_components.li, {
            children: ["Contact: +82 2 6956 7218, ", _jsx(_components.a, {
              href: "mailto:jongha.kim@ship-da.com",
              children: "jongha.kim@ship-da.com"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Personal Information Protection Manager"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Name: Jinkyu Park"
          }), "\n", _jsx(_components.li, {
            children: "Position: Team Leader"
          }), "\n", _jsxs(_components.li, {
            children: ["Contact: +82 2 6956 7218, ", _jsx(_components.a, {
              href: "mailto:innfi@ship-da.com",
              children: "innfi@ship-da.com"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "For any inquiries, complaints, consultations, or remedies regarding personal information protection that arise during the use of the Company's services (or business), you may contact the Personal Information Protection Officer or Manager. The Company will respond and handle your inquiries promptly and without delay."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 14 (Remedies for Infringement of Data Subject’s Rights)"
    }), "\n", _jsx(_components.p, {
      children: "Data subjects may seek resolution of disputes or consultation regarding personal information infringement by contacting the Personal Information Dispute Mediation Committee or the Personal Information Infringement Reporting Center under the Korea Internet & Security Agency (KISA). For additional inquiries or reports of personal information infringement, you may contact the following institutions:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Personal Information Dispute Mediation Committee"
          }), "\n", _jsx(_components.a, {
            href: "http://www.kopico.go.kr",
            children: "www.kopico.go.kr"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Personal Information Infringement Reporting Center"
          }), "\n", _jsx(_components.a, {
            href: "http://privacy.kisa.or.kr",
            children: "privacy.kisa.or.kr"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Supreme Prosecutors' Office"
          }), "\n", _jsx(_components.a, {
            href: "http://www.spo.go.kr",
            children: "www.spo.go.kr"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Cyber Bureau of the National Police Agency"
          }), "\n", _jsx(_components.a, {
            href: "http://ecrm.cyber.go.kr",
            children: "ecrm.cyber.go.kr"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.br, {}), _jsx(_components.br, {})]
    }), "\n", _jsx(_components.h4, {
      children: "You can check the history of changes to the Privacy Policy below:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "n/a"
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
